"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.facebookAdsPixelList = exports.facebookAdsPixelListResultSchema = exports.facebookAdsPixelListArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.facebookAdsPixelListArgsSchema = zod_1.z.object({
    limit: zod_1.z
        .number()
        .optional()
        .nullable()
        .describe('Maximum number of pixels to return (default: 100)'),
    emitMode: zod_1.z.enum(['single', 'multi']).default('single').describe('Emit mode for results'),
});
exports.facebookAdsPixelListResultSchema = zod_1.z.object({
    pixels: zod_1.z
        .array(zod_1.z.object({
        id: zod_1.z.string().describe('Pixel ID'),
        name: zod_1.z.string().describe('Pixel name'),
    }))
        .describe('List of Facebook pixels'),
    total_count: zod_1.z.number().describe('Total number of pixels'),
});
exports.facebookAdsPixelList = (0, common_1.createToolMetadata)({
    id: 'facebookAdsPixelList',
    displayName: 'Facebook Pixel List',
    displayDescription: 'List all Facebook pixels in the ad account',
    category: 'ads',
    color: common_1.BRAND_COLORS.META,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.META),
    icon: 'meta',
    argsSchema: exports.facebookAdsPixelListArgsSchema,
}, exports.facebookAdsPixelListResultSchema);
